import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Button, DatePicker, Row, Col, Form } from "antd";
import { SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

import {
    saveReleaseNote
} from '../actions';

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 20 },
}

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ size: [] }],
        [{ font: [] }],
        [{ align: ["right", "center", "justify"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        [{ color: ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0091dc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'] }]
    ]
};

const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font"
];
class EditReleaseNote extends Component {

    state = {
        editorState: '',
        resource: {},
        lang: 0,
    }

    UNSAFE_componentWillMount() {
        this.setState({
            resource: this.props.resource,
            editorState: this.props.resource.value || ''
        });
    }

    handleChange = (editorState) => {
        this.setState({ editorState })
    }

    hanleTitleChange = (e) => {
        let res = { ...this.state.resource };
        res.title = e.target.value;

        this.setState({ resource: res })
    }
    handleDateChange = (date) => {
        let res = { ...this.state.resource };
        res.createdOn = dayjs.isDayjs(date) ? date.utc(true) : date
        this.setState({ resource: res })
    }

    onSaveClicked = async () => {
        let res = { ...this.state.resource };
        res.value = this.state.editorState;
        await this.props.saveReleaseNote(this.props.lang, res);
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
    render() {
        return (
            <div className='startscreen'>
                <Form.Item colon={false} label=' ' {...formItemLayout}>
                    <Button style={{ margin: 5 }} type="primary" onClick={() => { this.onSaveClicked() }} icon={<SaveOutlined />} >Save / Opslaan</Button>
                </Form.Item>

                <Form.Item label='Title / Titel' {...formItemLayout}>
                    <Input value={this.state.resource.title} onChange={this.hanleTitleChange} />
                </Form.Item>

                <Form.Item label='Date / Datum' {...formItemLayout}>
                    <DatePicker value={dayjs.utc(this.state.resource.createdOn)} onChange={this.handleDateChange}
                        format={'DD-MM-YYYY'}
                        allowClear={false}
                        showTime={false} />
                </Form.Item>

                <Form.Item label='Text / Tekst' {...formItemLayout}>
                    <ReactQuill
                        theme="snow"
                        value={this.state.editorState}
                        onChange={this.handleChange}
                        modules={modules}
                        formats={formats}
                    />
                </Form.Item>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {

    };
}

export default connect(mapStateToProps,
    {
        saveReleaseNote
    })(EditReleaseNote);
